import { render, staticRenderFns } from "./DigitalAcceptanceContract.vue?vue&type=template&id=b56b9f94&scoped=true&"
import script from "./DigitalAcceptanceContract.vue?vue&type=script&lang=js&"
export * from "./DigitalAcceptanceContract.vue?vue&type=script&lang=js&"
import style0 from "./DigitalAcceptanceContract.vue?vue&type=style&index=0&id=b56b9f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56b9f94",
  null
  
)

export default component.exports